import { httpService } from '../../../configs/initHttpService';
import { BaseService } from '../../BaseService';
import { BaseResponse } from '../../interfaces';
import {
    GetTaskParams,
    PlannedArrivalDateResponse,
    RequestCallbackParams,
    RequestCallbackResponse,
    TaskResponse,
    TasksResponse,
} from './interfaces';

export class TaskService extends BaseService {
    readonly getTasks = (params: Partial<GetTaskParams>) =>
        this.http
            .get<BaseResponse<TasksResponse>>(`/v1/organization/external/tasks`, {
                params,
            })
            .then((res) => res.data.response);

    readonly getTask = ({ id }: Partial<GetTaskParams>) =>
        this.http
            .get<BaseResponse<TaskResponse>>(`/v1/organization/external/task/${id}`)
            .then((res) => res.data.response);

    readonly getPlannedArrivalDate = ({ id }: Partial<GetTaskParams>) =>
        this.http
            .get<
                BaseResponse<PlannedArrivalDateResponse>
            >(`/v1/organization/external/task/${id}/arrivals/planned`)
            .then((res) => res.data.response);

    readonly requestCallback = ({ id, senderFullName, shopCity, comment }: RequestCallbackParams) =>
        this.http
            .post<BaseResponse<RequestCallbackResponse>>(
                `/v1/organization/external/task/${id}/b2c-client-callback-request`,
                {
                    sender_full_name: senderFullName,
                    shop_address: shopCity,
                    comment,
                },
                { bypassGlobalErrorHandler: true },
            )
            .then((res) => res.data);
}

export const taskService = new TaskService(httpService);